import React from "react";
import { is } from "ramda";

const CreditLineRender = ({ credits }) => {
    return (
        <>
            {
                credits.map((credit, index) => {
                    return (
                        <p className="credit-line" key={index}>
                            {credit.name} - R$ {credit.availableAmount}
                        </p>
                    );
                })
            }
        </>
    );
};  

const CreditResumeLineRender = ({ credits }) => {
    return (
            <div>
                <span>Créditos Disponíveis:</span>
                <CreditLineRender credits={credits}/>
            </div>
    );
};

const CreditResume = ({ contextualRebooking })  => {

    if (!contextualRebooking) {
        return null;
    }

    return (
        <>
            <CreditResumeLineRender credits={contextualRebooking.credits} />
            <hr />
        </>
    );
};

export default CreditResume;
